import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';
import { setSearchStr } from '@wconcept/wconcept-common/utils/commonUtils';

export const DynmBtn = styled.div`
  ${mixin.flex({ display: 'inline-flex', justify: 'flex-start' })}
  height: 32px;

  .text {
    font-size: 14px;
    line-height: 130%;
    text-align: left;

    & + svg {
      margin-left: 2px;
    }
  }

  .btn {
    height: inherit;
  }

  ${props => {
    const cName = props.className || '';
    switch (true) {
      case setSearchStr(cName, 'word'):
        return css`
          background-color: #f9f9f9;
          max-width: 215px;
          padding: 0px 10px;

          .text {
            color: #434343;
            max-width: 175px;
          }
        `;
      case setSearchStr(cName, 'saleTag'):
        return css`
          background: #fff;
          border: 1px solid #eee;
          border-radius: 30px;

          .btn {
            padding: 0px 12px;
          }

          .text {
            color: #555;
          }

          &.active {
            border-color: #000;

            .text {
              color: #000;
            }
          }
        `;
      case setSearchStr(cName, 'filter'):
        return css`
          background: #fff;
          border: 1px solid #eee;
          border-radius: 30px;

          .btn {
            padding: 0px 10px 0px 12px;
          }

          .text {
            color: #555;
          }

          &.active {
            border-color: #000;

            .btn:not(.btn-close) path {
              fill: #000 !important;
            }

            .text {
              color: #000;
            }
          }

          &.type-close {
            height: 29px;
            border: 0;
            background-color: #f6f6f6;

            .btn {
              .text {
                font-size: 13px;
                color: #333;

                & + svg {
                  margin-left: 4px;
                }
              }
            }
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('32')};

    .text {
      font-size: ${mixin.pxToVw('14')};

      & + svg {
        margin-left: ${mixin.pxToVw('2')};
      }
    }

    ${props => {
      const cName = props.className || '';
      switch (true) {
        case setSearchStr(cName, 'word'):
          return css`
            max-width: ${mixin.pxToVw('215')};
            padding: ${mixin.pxToVw('0 10')};

            .text {
              max-width: ${mixin.pxToVw('175')};
            }
          `;
        case setSearchStr(cName, 'saleTag'):
          return css`
            border-radius: ${mixin.pxToVw('30')};

            .btn {
              padding: ${mixin.pxToVw('0 12')};
            }
          `;
        case setSearchStr(cName, 'filter'):
          return css`
            border-radius: ${mixin.pxToVw('30')};

            .btn {
              padding: ${mixin.pxToVw('0 10 0 12')};
            }

            &.type-close {
              height: ${mixin.pxToVw('29')};

              .btn {
                .text {
                  font-size: ${mixin.pxToVw('13')};

                  & + svg {
                    margin-left: ${mixin.pxToVw('4')};
                  }
                }
              }
            }
          `;
        default:
          return null;
      }
    }}
  }

  @media ${({ theme }) => theme.media.pc} {
    height: 37px;
    border-radius: 37px;

    .text {
      font-size: 16px;

      & + svg {
        margin-left: 4px;
      }
    }

    ${props => {
      const cName = props.className || '';
      switch (true) {
        case setSearchStr(cName, 'saleTag'):
          return css`
            .btn {
              padding: 0 16px;
            }
          `;
        case setSearchStr(cName, 'filter'):
          return css`
            .btn {
              padding: 0 14px 0 16px;
            }

            &.type-close {
              height: 30px;

              .btn {
                padding: 0 12px;

                .text {
                  font-size: 14px;

                  & + svg {
                    margin-left: 7px;
                    width: 10px;
                    height: 10px;
                  }
                }
              }
            }
          `;
        default:
          return null;
      }
    }}
  }
`;
